import { createReducer } from '@ngrx/store';

export type ApplicationState = NonNullable<unknown>;

export const initialState: ApplicationState = {};

export const applicationReducer = createReducer<ApplicationState>(initialState);
